export * from './lib/fontawesome-import.module';
